'use strict';

define(['app', '$location'], function (app, $location) {

  var headerSearch = function headerSearch() {
    var self = this;

    var _config = {
      data: {
        customerLocale: 'data-customer-locale',
        currencyType: 'data-currency',
        searchResultsContainer: 'data-search-results'
      },
      selectors: {
        toggleFormButton: '[data-toggle-form]',
        form: '[data-form]',
        searchField: '[data-search]',
        option: '[data-option]',
        searchResultsContainer: '[data-search-results]',
        hideSearchResultsButton: '[data-hide-search-results-button]'
      },
      classes: {
        toggleOpen: 'headerSearch_toggleForm-open',
        showForm: 'headerSearch_form-show',
        active: 'headerSearch_resultsListItem-active',
        searchResultsContainer: 'headerSearch_resultsContainer',
        searchFieldVisibleResults: 'headerSearch_input-resultsVisible',
        hideSearchResults: 'headerSearch_results-hide',
        showHideSearchResultsButton: 'headerSearch_hideResults-show'
      },
      queryExecuted: false,
      searchEndpointSuffix: '/headerSearch_results/headersearch.nav?autocompleteRequest=',
      fullSearchEndpoint: null,
      lastSearchString: null,
      lastKeyPress: null,
      lastSearchTimeout: null,
      specialKeys: {
        'UP': 38,
        'DOWN': 40,
        'RETURN': 13,
        'ESC': 27
      },
      visibleResults: false,
      results: [],
      selectedIndex: null,
      previousSelected: null,
      minChars: 2,
      error: false
    };

    var _init = function _init(element) {
      self.element = element;
      self.toggleFormButton = self.element.querySelector(self.config.selectors.toggleFormButton);
      self.form = self.element.querySelector(self.config.selectors.form);
      self.searchField = self.element.querySelector(self.config.selectors.searchField);
      self.customerLocale = self.element.getAttribute(self.config.data.customerLocale);
      self.currency = self.element.getAttribute(self.config.data.currencyType);
      self.searchResults = null;
      self.searchResultsContainer = null;
      self.hideSearchResultsButton = self.element.querySelector(self.config.selectors.hideSearchResultsButton);

      self.config.fullSearchEndpoint = '/' + self.customerLocale + '/' + self.currency + self.config.searchEndpointSuffix;

      self.addEventListeners();
      self.createSearchResultsContainer();
      self.checkForParam();

      return self;
    };

    var _addEventListeners = function _addEventListeners() {
      self.toggleFormButton.addEventListener('click', self.toggleForm);
      self.searchField.addEventListener('keydown', self.keyDownEventHandler);
      self.searchField.addEventListener('keyup', self.keyUpEventHandler);
      self.searchField.addEventListener('focus', self.focusEventHandler);
      self.hideSearchResultsButton.addEventListener('click', self.hideSearchResults);
    };

    var _createSearchResultsContainer = function _createSearchResultsContainer() {
      var container = document.createElement('div');
      container.setAttribute('class', self.config.classes.searchResultsContainer);
      container.setAttribute(self.config.data.searchResultsContainer, '');
      self.element.appendChild(container);
      self.searchResultsContainer = self.element.querySelector(self.config.selectors.searchResultsContainer);
    };

    var _toggleForm = function _toggleForm() {
      self.toggleButtonClass();
      self.toggleShowForm();
    };

    var _toggleButtonClass = function _toggleButtonClass() {
      if (app.element.hasClass(self.config.classes.toggleOpen, self.toggleFormButton)) {
        app.element.removeClass(self.config.classes.toggleOpen, self.toggleFormButton);
      } else {
        app.element.addClass(self.config.classes.toggleOpen, self.toggleFormButton);
      }
    };

    var _toggleShowForm = function _toggleShowForm() {
      if (app.element.hasClass(self.config.classes.showForm, self.form)) {
        app.element.removeClass(self.config.classes.showForm, self.form);
        self.config.searchFieldVisible = false;
      } else {
        app.element.addClass(self.config.classes.showForm, self.form);
        self.config.searchFieldVisible = true;
      }
    };

    var _doSearch = function _doSearch() {
      self.config.queryExecuted = true;
      self.config.error = false;

      return app.ajax.get({
        url: self.config.fullSearchEndpoint + self.config.lastSearchString,
        dataType: 'JSON',
        error: self.errorCallback,
        success: self.populateSearchResults
      });
    };

    var _errorCallback = function _errorCallback() {
      self.config.error = true;
    };

    var _checkForParam = function _checkForParam() {
      var match = $location.href.match(/[\?&]search=([^&]*)/);
      if (match) {
        self.searchField.value = decodeURIComponent(match[1]).replace(/\+/g, ' ');
      }
    };

    var _keyUpEventHandler = function _keyUpEventHandler(e) {
      self.config.lastKeyPress = e.keyCode;

      if (e.keyCode === self.config.specialKeys.UP) return self.keyNavigationHandler('up');
      if (e.keyCode === self.config.specialKeys.DOWN) return self.keyNavigationHandler('down');
      if (e.keyCode === self.config.specialKeys.ESC) return self.hideSearchResults();

      self.config.lastSearchString = e.target.value;

      if (e.target.value.length < self.config.minChars) return self.hideSearchResults();

      // limit search requests to one per half second
      clearTimeout(self.lastSearchTimeout);
      self.lastSearchTimeout = setTimeout(self.doSearch, 500);
    };

    var _keyDownEventHandler = function _keyDownEventHandler(e) {
      self.config.lastKeyPress = e.keyCode;

      if (e.keyCode === self.config.specialKeys.RETURN) {
        // only change the behaviour if there is a selected item in the autocomplete list
        // otherwise it will interfere with the default form submit
        if (self.config.selectedIndex !== null) {
          e.preventDefault ? e.preventDefault() : e.returnValue = false;
          self.config.results[self.config.selectedIndex].children[0].click();
        }
      }
    };

    var _keyNavigationHandler = function _keyNavigationHandler(direction) {
      if (self.config.results.length) {
        if (direction === 'up') {
          if (self.config.selectedIndex === null || self.config.selectedIndex === 0) {
            self.config.selectedIndex = null;
          } else {
            self.config.selectedIndex--;
          }
        } else if (direction === 'down') {
          if (self.config.selectedIndex === null) {
            self.config.selectedIndex = 0;
          } else if (self.config.selectedIndex >= self.config.results.length - 1) {
            self.config.selectedIndex = self.config.results.length - 1;
          } else {
            self.config.selectedIndex++;
          }
        }

        if (self.config.previousSelected !== null) {
          app.element.removeClass(self.config.classes.active, self.config.previousSelected);
        }

        if (self.config.selectedIndex !== null) {
          app.element.addClass(self.config.classes.active, self.config.results[self.config.selectedIndex]);
          self.config.previousSelected = self.config.results[self.config.selectedIndex];
        }
      }
    };

    var _focusEventHandler = function _focusEventHandler(e) {
      if (self.config.queryExecuted && e.target.value.length >= self.config.minChars && e.target.value === self.config.lastSearchString) {
        self.showSearchResults();
      }
    };

    var _hideSearchResults = function _hideSearchResults() {
      if (self.config.visibleResults) {
        app.element.addClass(self.config.classes.hideSearchResults, self.searchResultsContainer);
        app.element.removeClass(self.config.classes.searchFieldVisibleResults, self.searchField);
        self.config.selectedIndex = null;
        self.config.visibleResults = false;
        self.hideHideSearchResultsButton();
      }
    };

    var _populateSearchResults = function _populateSearchResults(response) {
      self.searchResultsContainer.innerHTML = response;
      self.config.results = self.searchResultsContainer.querySelectorAll(self.config.selectors.option);
      self.showSearchResults();
    };

    var _showSearchResults = function _showSearchResults() {
      app.element.removeClass(self.config.classes.hideSearchResults, self.searchResultsContainer);
      app.element.addClass(self.config.classes.searchFieldVisibleResults, self.searchField);
      self.config.visibleResults = true;
      self.showHideSearchResultsButton();
    };

    var _showHideSearchResultsButton = function _showHideSearchResultsButton() {
      app.element.addClass(self.config.classes.showHideSearchResultsButton, self.hideSearchResultsButton);
    };

    var _hideHideSearchResultsButton = function _hideHideSearchResultsButton() {
      app.element.removeClass(self.config.classes.showHideSearchResultsButton, self.hideSearchResultsButton);
    };

    self.config = _config;
    self.init = _init;
    self.addEventListeners = _addEventListeners;
    self.createSearchResultsContainer = _createSearchResultsContainer;
    self.toggleForm = _toggleForm;
    self.toggleButtonClass = _toggleButtonClass;
    self.toggleShowForm = _toggleShowForm;
    self.doSearch = _doSearch;
    self.errorCallback = _errorCallback;
    self.focusEventHandler = _focusEventHandler;
    self.keyDownEventHandler = _keyDownEventHandler;
    self.keyNavigationHandler = _keyNavigationHandler;
    self.keyUpEventHandler = _keyUpEventHandler;
    self.hideSearchResults = _hideSearchResults;
    self.populateSearchResults = _populateSearchResults;
    self.showSearchResults = _showSearchResults;
    self.checkForParam = _checkForParam;
    self.showHideSearchResultsButton = _showHideSearchResultsButton;
    self.hideHideSearchResultsButton = _hideHideSearchResultsButton;
  };

  return headerSearch;
});
//# sourceMappingURL=headerSearch.js.map
